import type { FieldDatabase, PhotoBlobRecord } from '@/shared/db/schema';

export class PhotoBlobRepository {
  constructor(private readonly database: FieldDatabase) {}

  async save(record: PhotoBlobRecord) {
    await this.database.put('photo_blobs', (await serializeBlobRecord(record)) as unknown as PhotoBlobRecord);
  }

  async get(id: string) {
    return hydrateBlobRecord(await this.database.get('photo_blobs', id));
  }

  async delete(id: string) {
    await this.database.delete('photo_blobs', id);
  }
}

async function serializeBlobRecord(record: PhotoBlobRecord) {
  return {
    ...record,
    blob: await new Response(record.blob).arrayBuffer(),
  };
}

function hydrateBlobRecord(record: PhotoBlobRecord | undefined): PhotoBlobRecord | undefined {
  if (!record) {
    return undefined;
  }

  if (record.blob instanceof Blob) {
    return record;
  }

  const storedBlob = record.blob as unknown;

  if (storedBlob instanceof ArrayBuffer) {
    return {
      ...record,
      blob: new Blob([storedBlob], { type: record.mimeType }),
    };
  }

  if (ArrayBuffer.isView(storedBlob)) {
    const bytes = new Uint8Array(storedBlob.byteLength);
    bytes.set(new Uint8Array(storedBlob.buffer, storedBlob.byteOffset, storedBlob.byteLength));

    return {
      ...record,
      blob: new Blob([bytes.buffer as ArrayBuffer], { type: record.mimeType }),
    };
  }

  return record;
}
